import MenuItem, { MenuItemRenderProps } from '../../menu-item';
import { Link } from 'react-router-dom';
import { Category } from '../../../types/catalog';

const MenuItemRender = ({
    isOpen,
    hasChildren,
    onOpen,
    isCurrentPath,
    url,
    name,
    children,
}: MenuItemRenderProps) => (
    <li className={'catalog-menu-item' + (isOpen ? ' catalog-menu-item--active' : '')}>
        {hasChildren && <span className="catalog-menu-item__icon" onClick={onOpen} />}
        <Link
            to={url}
            className={'catalog-menu-item__link' + (isCurrentPath ? ' catalog-menu-item__link--active' : '')}
        >
            {name}
        </Link>
        {isOpen && (
            <ul className="catalog-menu__submenu">
                {children?.map((item) => (
                    <MenuItem key={item.slug} {...item} render={MenuItemRender} />
                ))}
            </ul>
        )}
    </li>
);
const NewIekMenuItem = (cat: Category) => {
    return <MenuItem {...cat} render={MenuItemRender} />;
};

export default NewIekMenuItem;
